import React from 'react'

// Doctor's phone and email for the printed order label, shared by the labadmin and doctor
// labels. The label API returns them as `doctorcontact` and `doctoremail`.
//
// One line, side by side, to save height on the sticker; a long email wraps on its own.
// Each part is dropped when empty, and the whole line when both are.
const Index = ({ order }) => {
    const clean = (v) => (v == null ? '' : String(v).trim());
    const phone = clean(order.doctorcontact);
    const email = clean(order.doctoremail);

    if (phone === '' && email === '') return null;
    return (
        <p>
            {phone !== '' && <>Phone: <b>{phone}</b></>}
            {phone !== '' && email !== '' && <span style={{display:"inline-block", width:"8pt"}}/>}
            {email !== '' && <>Email: <b>{email}</b></>}
        </p>
    );
}

export default Index
